module.exports = __webpack_public_path__ + "static/media/elavator_sketch.f3d3c7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Ideation/img/elavator_sketch.png
// module id = 137
// module chunks = 0